// frontend_react/src/components/RestaurantCategoriesPanel.jsx

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  getRestaurantCategories,
  createRestaurantCategory,
  updateRestaurantCategory,
  deleteRestaurantCategory,
} from "../../services/adminApi";
import { useAdminScope } from "../../context/AdminScopeContext";
import { useAdminConfirmation } from "../../pages/admin/panel_engine/consumer";
import { AdminButton } from "../../pages/admin/action_engine";

import {
  AdminActions,
} from "../../pages/admin/section_engine";

export default function RestaurantCategoriesPanel() {

  const [categories, setCategories] = useState([]);
  const [editingUuid, setEditingUuid] = useState(null);

  const [newName, setNewName] = useState("");
  const [newOrder, setNewOrder] = useState(0);

  const [draft, setDraft] = useState({});

  const { selectedCompanyUuid } = useAdminScope();
  const confirm = useAdminConfirmation();

  const companyScope = selectedCompanyUuid
    ? { companyUuid: selectedCompanyUuid }
    : {};

  const loadCategories = async () => {
    const { data } = await getRestaurantCategories(companyScope);

    setCategories(
      [...data].sort((a, b) => a.order - b.order)
    );
  };

  useEffect(() => {
    loadCategories();
  }, [selectedCompanyUuid]);

  const handleCreate = async () => {
    if (!newName.trim()) return;

    await createRestaurantCategory(
      {
        name: newName,
        order: newOrder,
      },
      companyScope
    );

    setNewName("");
    setNewOrder(0);

    loadCategories();
  };

  const handleDelete = async (uuid) => {
    const confirmed = await confirm({
      title: "Supprimer la catégorie ?",
      message: "Supprimer cette catégorie ?",
      confirmLabel: "Supprimer",
      cancelLabel: "Conserver",
      intent: "danger",
    });

    if (!confirmed) return;

    await deleteRestaurantCategory(uuid, companyScope);
    loadCategories();
  };

  const startEdit = (cat) => {
    setEditingUuid(cat.uuid);

    setDraft({
      name: cat.name,
      order: cat.order,
    });
  };

  const saveEdit = async (uuid) => {

    await updateRestaurantCategory(uuid, draft, companyScope);

    setEditingUuid(null);
    setDraft({});

    loadCategories();
  };

  return (
    <Wrapper>

      <CreateCard>

        <CardTitle>
          Nouvelle catégorie
        </CardTitle>

        <Field>
          <label htmlFor="category-name">Nom</label>
          <input
            id="category-name"
            value={newName}
            onChange={(e) =>
              setNewName(e.target.value)
            }
          />
        </Field>

        <Field>
          <label htmlFor="category-order">Ordre</label>
          <input
            id="category-order"
            type="number"
            value={newOrder}
            onChange={(e) =>
              setNewOrder(Number(e.target.value))
            }
          />
        </Field>

        <AdminButton variant="success" fullWidth type="button"
          onClick={handleCreate}
        >
          Ajouter
        </AdminButton>

      </CreateCard>

      <CategoryList>

        {categories.map((cat) => {

          const editing =
            editingUuid === cat.uuid;

          return (

            <CategoryCard key={cat.uuid}>

              {editing ? (
                <>
                  <Field>
                    <label htmlFor="category-name">Nom</label>
                    <input
                      id="category-name"
                      value={draft.name}
                      onChange={(e) =>
                        setDraft({
                          ...draft,
                          name: e.target.value,
                        })
                      }
                    />
                  </Field>

                  <Field>
                    <label htmlFor="category-order">Ordre</label>
                    <input
                      id="category-order"
                      type="number"
                      value={draft.order}
                      onChange={(e) =>
                        setDraft({
                          ...draft,
                          order:
                            Number(
                              e.target.value
                            ),
                        })
                      }
                    />
                  </Field>

                  <AdminActions>

                    <AdminButton variant="success" fullWidth type="button"
                      onClick={() =>
                        saveEdit(cat.uuid)
                      }
                    >
                      Enregistrer
                    </AdminButton>

                    <AdminButton variant="ghost" fullWidth type="button"
                      onClick={() =>
                        setEditingUuid(null)
                      }
                    >
                      Annuler
                    </AdminButton>

                  </AdminActions>
                </>
              ) : (
                <>
                  <TopLine>

                    <strong>
                      {cat.name}
                    </strong>

                    <Badge>
                      Ordre {cat.order}
                    </Badge>

                  </TopLine>

                  <AdminActions>

                    <AdminButton variant="ghost" fullWidth type="button"
                      onClick={() =>
                        startEdit(cat)
                      }
                    >
                      Modifier
                    </AdminButton>

                    <AdminButton variant="danger" fullWidth type="button"
                      onClick={() =>
                        handleDelete(cat.uuid)
                      }
                    >
                      Supprimer
                    </AdminButton>

                  </AdminActions>
                </>
              )}

            </CategoryCard>
          );
        })}

      </CategoryList>

    </Wrapper>
  );
}

const Wrapper = styled.div`
  color: #f7f7f7;
`;

const CreateCard = styled.div`
  display: grid;
  gap: 0.8rem;
  padding: 1rem;
  border-radius: 16px;
  background: #202a43;
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

const CardTitle = styled.h4`
  margin: 0 0 0.3rem;
  font-size: 1rem;
  font-weight: 950;
`;

const Field = styled.div`
  display: grid;
  gap: 0.35rem;

  label {
    font-size: 0.78rem;
    font-weight: 850;
    opacity: 0.82;
  }

  input {
    width: 100%;
    border: none;
    border-radius: 10px;
    padding: 0.75rem;
    background: #fff9ea;
    color: #0b1328;
    font-weight: 750;
    box-sizing: border-box;
    outline: none;
  }
`;

const CategoryList = styled.div`
  display: grid;
  gap: 0.9rem;
  margin-top: 1rem;
`;

const CategoryCard = styled.article`
  padding: 1rem;
  border-radius: 16px;
  background: #202a43;
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

const TopLine = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;

  strong {
    display: block;
    font-weight: 950;
  }
`;

const Badge = styled.span`
  height: fit-content;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  background: #fff9ea;
  color: #0b1328;
  font-size: 0.75rem;
  font-weight: 950;
  white-space: nowrap;
`;
